import React from 'react'
import Navbar from '../inc/Navbar'
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

import { Link } from "react-router-dom";
import Multicuisine from './Multicuisine';
import vojanmenu from "../images/VILA’S VOJAN Menu.pdf"
import mainmenu from "../images/VILA’S VOJAN Menu_page-0002.jpg";
import vilasvojan from "../images/VILA’S VOJAN Menu_page-0003.jpg";
import vilasvojan_vegindianmaincourse from "../images/VILA’S VOJAN Menu_page-0004.jpg";
import vilasvojan_beverage from "../images/VILA’S VOJAN Menu_page-0005.jpg"
import thank_you from "../images/VILA’S VOJAN Menu_page-0006.jpg";


function Restrovilas() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div style={{ color: "Green", display: 'flex', justifyContent: 'flex-start', margin: "2px" }} className="fixed-bottom shadow mb-1">
        <a className='vevaroomberhampore shadow' href='tel: 9046258702'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" style={{ color: "white" }} fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
          <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
        </svg> Contact us  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
            <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
          </svg></a>
      </div>
      <div className='familyroom'>
        <div className="album py-2">
          <div className="container mt-2">
            <h3 className='mb-0' style={{ color: "white" }}> Multicuisine Restaurant </h3>
            <hr className='mb-1' style={{ color: "white" }} />
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" style={{ color: "white" }} >Home</Link></li>

                <li className="breadcrumb-item"><Link to="/restaurant" style={{ color: "white" }} >Back</Link></li>
                <li style={{ color: "white" }} className="breadcrumb-item active" aria-current="page">Multicuisine Photo, Multicuisine Menu</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className='album py-2'>
        <div className='container'>
          <div className="row">
            <div className="col-md-4 mt-3">
              <a href={vojanmenu} target="_blank" rel="noopener noreferrer">
                <button className='button12 button13'>VOJAN MENU DOWNLOAD <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-cloud-download" viewBox="0 0 16 16">
                  <path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383" />
                  <path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z" />
                </svg></button>
              </a>
            </div>


            <div className='album py-0'>
              <div className='container'>
                <div className="row">
                  <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={mainmenu} className="card-img-top" alt="restaurant_berhampore murshidabad" />
                      </Zoom>
                    </div>
                  </div>
                  <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={vilasvojan} className="card-img-top" alt="vilasvojan" />
                      </Zoom>
                    </div>
                  </div>
                  <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={vilasvojan_vegindianmaincourse} className="card-img-top" alt="vilasvojan" />
                      </Zoom>
                    </div>
                  </div>
                  <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={vilasvojan_beverage} className="card-img-top" alt="vilasvojan" />
                      </Zoom>
                    </div>
                  </div>
                  <div className="col-md-3 mt-2">
                    <div className='imgradius'>
                      <Zoom>
                        <img src={thank_you} className="card-img-top" alt="vilasvojan" />
                      </Zoom>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div className="col-md-8 mt-3">

            </div>
          </div>
        </div>
      </div>
      <Multicuisine />

      <br />
      <br />

    </div>
  )
}

export default Restrovilas